module.exports = __webpack_public_path__ + "static/media/31.c45bddd5.jpg";